import React from 'react';

const NotFoundPage: React.FC = () => {
  return (
    <div>
      <h1>404: Page Not Found</h1>
    </div>
  );
};

export default NotFoundPage;
